import { withRouter } from 'react-router'

import { Dashboard } from './Dashboard'
import { withAdalLoginApi } from '../../adalConfig'

const DashboardContainer = process.env.NODE_ENV === 'development'
  ? withRouter(Dashboard)
  : withAdalLoginApi(withRouter(Dashboard), () => null, (e: string) => null )

export {
  DashboardContainer
}
